'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.endOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/endOfYear.js
// module id = 493
// module chunks = 0